export * from '@primeuix/themes/nora/blockui';
export { default } from '@primeuix/themes/nora/blockui';
